import styled, { css } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { IGNORED } from '@rsos/constants/alertStatuses';

export const CHAT_HEADER_HEIGHT = 60;
export const PRIVILEGED_CHAT_MARGIN = 10;

const grayedOut = css`
  opacity: 0.4;
`;

export const AlertChatBoxContainer = styled(Box).attrs(
  ({ isChatBoxVisible }) => ({
    width: '100%',
    grow: true,
    borderRadius: '5px',
    borderWidth: '1px',
    height: isChatBoxVisible ? 'auto' : '0',
  }),
)``;

export const TalkJSContainer = styled(Box).attrs(
  ({ chatBoxHeight, alertActionsHeight, isChatBoxVisible }) => ({
    flex: '1 1 auto',
    width: '100%',
    height: isChatBoxVisible
      ? `calc(${chatBoxHeight} - ${alertActionsHeight} - ${CHAT_HEADER_HEIGHT}px)`
      : '0',
    backgroundColor: 'background',
    borderRadius: '5px',
  }),
)``;

export const AlertActions = styled(Box).attrs({
  flex: '0 0 auto',
  height: 'auto',
  backgroundColor: 'background',
})`
  ${({ alertStatus, showRemoveAlert }) =>
    alertStatus === IGNORED && !showRemoveAlert && grayedOut};
`;
